import React from 'react'

import { Box, Container, Hidden, Paper, makeStyles } from '@material-ui/core'
import coalitionLogo from 'assets/coalition-logo.png'
import coalitionLogo2x from 'assets/coalition-logo@2x.png'
import coalitionLogoWebp from 'assets/coalition-logo.webp'
import coalitionLogoWebp2x from 'assets/coalition-logo@2x.webp'
import scoirLogo from 'assets/scoir-logo.svg'
import { useLocation } from 'react-router-dom'

import DemoBanner from 'components/DemoBanner'
import Footer from 'components/Footer'
import Snackbar from 'components/Snackbar'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: '100vh',
    background: `linear-gradient(180deg, #7ED2FC 0%, #B0EAE4 100%)`,
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  container: {
    margin: 'auto',
  },
  main: {
    margin: theme.spacing(3, 0),
    padding: theme.spacing(3),
    textAlign: 'center',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  logo: {
    flexShrink: 0,
    margin: 'auto',
  },
  backButton: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: 0,
  },
}))

const InAppLayout = ({ children }: { children: React.ReactNode }) => {
  const classes = useStyles()
  const { pathname } = useLocation()
  const withCoalition = pathname.includes('/app')

  return (
    <div className={classes.root}>
      <DemoBanner />
      <Container
        className={classes.container}
        fixed
        maxWidth="xs"
      >
        <Paper
          elevation={0}
          className={classes.main}
        >
          <Box className={classes.logoContainer}>
            <img
              className={classes.logo}
              src={scoirLogo}
              alt="Scoir Logo"
            />
            {withCoalition && (
              <>
                <Box
                  aria-hidden="true"
                  m={2}
                >
                  <Hidden xsDown>
                    <span>X</span>
                  </Hidden>
                </Box>
                <picture>
                  <source
                    type="image/webp"
                    srcSet={`${coalitionLogoWebp} 175w, ${coalitionLogoWebp2x} 350w`}
                    sizes="175px"
                  />
                  <img
                    className={classes.logo}
                    src={coalitionLogo}
                    srcSet={`${coalitionLogo} 175w, ${coalitionLogo2x} 350w`}
                    sizes="175px"
                    width={175}
                    height={47}
                    alt="Coalition Logo"
                  />
                </picture>
              </>
            )}
          </Box>
          {children}
        </Paper>
      </Container>
      <Snackbar />
      <Footer />
    </div>
  )
}

export default InAppLayout
